<template>
    <div id="TempJoker">
        <div id="APlayerContainer"></div>
    </div>
</template>

<script setup>
import 'aplayer/dist/APlayer.min.css';
import APlayer from 'aplayer';
import { onMounted } from 'vue';

onMounted(() => {
    let artist = '薛之谦';
    new APlayer({
        container: document.getElementById('APlayerContainer'),
        mini: false,
        autoplay: true,
        theme: '#FADFA3',
        loop: 'all',
        order: 'list',
        preload: 'auto',
        volume: 0.7,
        mutex: true,
        listFolded: false,
        listMaxHeight: 90,
        lrcType: 1,
        audio: [
            {
                name: '媚人',
                artist: artist,
                url: require('@/assets/songs/MeiRen/m.mp3'),
                cover: require('@/assets/songs/MeiRen/c.jpg'),
                lrc: require('@/assets/songs/MeiRen/l.lrc'),
                theme: '#ebd0c2'
            },
            {
                name: '跃',
                artist: artist,
                url: require('@/assets/songs/Yue/m.mp3'),
                cover: require('@/assets/songs/Yue/c.jpg'),
                lrc: require('@/assets/songs/Yue/l.lrc'),
                theme: '#46718b'
            },
            {
                name: '守村人',
                artist: artist,
                url: require('@/assets/songs/ShouCunRen/m.mp3'),
                cover: require('@/assets/songs/ShouCunRen/c.jpg'),
                lrc: require('@/assets/songs/ShouCunRen/l.lrc'),
                theme: '#46718b'
            },
            {
                name: '迟迟',
                artist: artist,
                url: require('@/assets/songs/ChiChi/m.mp3'),
                cover: require('@/assets/songs/ChiChi/c.jpg'),
                lrc: require('@/assets/songs/ChiChi/l.lrc'),
                theme: '#46718b'
            },
            // {
            // name: '跃（中国唱将）',
            // }
        ]
    });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#TempJoker {
    width: 70%;
    // height: 50px;

    margin: 0 auto;
}
</style>
